import { AxiosResponse } from 'axios';

import {
  Clinic,
  ClinicBillingType,
  ClinicFormValues,
  Professional,
  ProfessionalPayload,
} from './types';
import { createRequestApi } from './state/requestTool';
import { fetchInfosZipCode } from 'services/iclinic/easyZipCode';
import { onlyNumbers } from 'shared/utils/formatters';
import { ZipCodeRawData } from 'services/iclinic/easyZipCode/types';
import iClinicApi from 'services/iclinic/iClinicApi';

export const getClinicDetails = (
  clinicId: number,
): Promise<AxiosResponse<Clinic>> =>
  iClinicApi.get(`/clinics/clinic/${clinicId}`);

export const getProfessionalDetails = (
  physicianId: string,
): Promise<AxiosResponse<Professional>> =>
  iClinicApi.get(`/accounts/physician/${physicianId}`);

export const getBillingClinic = (
  subscriptionId: string,
): Promise<AxiosResponse<ClinicBillingType>> =>
  iClinicApi.get(`/subscriptions/subscription/${subscriptionId}`);

export const updateProfessional = (
  physicianId: string,
  values: ProfessionalPayload,
) => iClinicApi.patch(`/accounts/physician/${physicianId}/`, values);

export const updateClinic = (clinicId: number, values: ClinicFormValues) =>
  iClinicApi.patch(`/clinics/clinic/${clinicId}/`, values);

export const updateBillingClinic = (
  subscriptionId: string,
  values: Partial<ClinicBillingType>,
) => iClinicApi.patch(`/subscriptions/subscription/${subscriptionId}/`, values);

export const {
  reducer: zipCodeReducer,
  takeLatestSaga: getZipCodeSaga,
  useRequestApi: useGetZipCode,
} = createRequestApi<ZipCodeRawData, string>({
  name: 'cfmupdate/zipCode',
  stateSelector: (state) => state.cfmUpdate.zipCode,
  requestFn: (zipCode: string) => fetchInfosZipCode(onlyNumbers(zipCode)),
});
